import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取资讯详情
   */
  static delInfo(data, type) {
    return request({
      url: `content/business/card`,
      method: type,
      data,
      host: config.HOST_MALL
    });
  }

  static queryHotArtList(params) {
    return request({
      url: 'content/query/relatedContent',
      host: config.HOST_PROMOTE,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/MemberBirthday/MemberBirthdayServ.js